import React from 'react';

const HyattBrandFlag = ({ scale = 1, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 60 60"
      width={20 * scale}
      height={20 * scale}
      {...props}
    >
      <path
        fill="#0072CE"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 -1.90735e-06 60)"
        d="M0 0L60 0L60 60L0 60L0 0Z"
      />
      <path
        fill="white"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 37.6358 53.3269)"
        d="M0 8.8391666L2.2097917 8.8391666L2.2097917 0L4.2285419 0L4.2285419 8.8389587L6.4385419 8.8389587L6.4385419 9.7160416L0 9.7160416L0 8.8391666Z"
      />
      <path
        fill="white"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 47.232 53.3269)"
        d="M0 8.8391666L2.21 8.8391666L2.21 0L4.2287502 0L4.2287502 8.8389587L6.4387498 8.8389587L6.4387498 9.7160416L0 9.7160416L0 8.8391666Z"
      />
      <path
        fill="white"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 27.0177 53.327)"
        d="M2.4372916 3.4112501L3.5095832 6.5616665L4.5179167 3.4112501L2.4372916 3.4112501ZM5.6095834 0L7.7008333 0L4.5927081 9.7160416L3.3072917 9.7160416L0 0L1.2760416 0L2.1422918 2.5452082L4.7950001 2.5452082L5.6095834 0Z"
      />
      <path
        fill="white"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 47.52 16.3892)"
        d="M2.66875 8.8474998C3.9666667 8.8474998 4.7739582 7.1504169 4.7754169 4.8485417C4.7739582 2.5997918 4.0033336 0.93916667 2.7581251 0.8745833L2.0177083 0.8745833L2.0177083 8.8474998L2.66875 8.8474998ZM-9.7699626e-15 9.7160416L-9.7699626e-15 0L3.0658333 0C5.4235415 0 6.7931252 1.8099999 6.7931252 4.855C6.7931252 7.8868752 5.4237499 9.7158337 3.0658333 9.7158337L-9.7699626e-15 9.7160416Z"
      />
      <path
        fill="white"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 28.4369 16.389)"
        d="M2.01875 4.8431249L2.01875 8.8468752L2.5572917 8.8468752C3.6556251 8.8468752 4.1066666 8.0818748 4.1066666 6.8766665C4.1066666 5.5124998 3.5633333 4.8429165 2.5572917 4.8429165L2.01875 4.8431249ZM6.7514582 0L4.6383333 4.2966666C5.660625 4.7131252 6.1418748 5.5352082 6.1418748 6.8764582C6.1418748 8.7835417 5.0379167 9.7158337 2.5931251 9.7158337L-9.7699626e-15 9.7160416L-9.7699626e-15 0L2.01875 0L2.01875 3.9737501L2.6433334 3.9749999L4.598125 0L6.7514582 0Z"
      />
      <path
        fill="white"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 5.57937 16.3892)"
        d="M8.0120831 9.7160416L6.7754169 4.3197918L5.5133333 9.7160416L4.4985418 9.7160416L3.2614584 4.3172917L1.9989583 9.7160416L0 9.7160416L2.2722917 0L3.286875 0L4.5475001 5.5010419L5.785625 0L6.8004165 0L9.0962496 9.7160416L8.0120831 9.7160416Z"
      />
      <path
        fill="white"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 6.67312 53.3271)"
        d="M4.6589584 5.2783332L2.0191667 5.2783332L2.0191667 9.7160416L0 9.7160416L0 0L2.0191667 0L2.0191667 4.4016666L4.6589584 4.4016666L4.6589584 0L6.6729169 0L6.6729169 9.7160416L4.6589584 9.7160416L4.6589584 5.2783332Z"
      />
      <path
        fill="white"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 17.0496 53.3271)"
        d="M6.7079167 9.7160416L4.4577084 5.5533333L2.1827083 9.7160416L0 9.7160416L2.8627083 4.5083332L2.8627083 0L4.8977084 0L4.8977084 4.4400001L7.7420835 9.7160416L6.7079167 9.7160416Z"
      />
      <path
        fill="white"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 38.9338 16.389)"
        d="M5.5656252 0.86916667L2.0193751 0.86916667L2.0193751 9.7160416L0 9.7160416L0 0L5.5656252 0L5.5656252 0.86916667Z"
      />
      <path
        fill="white"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 17.2873 16.5225)"
        d="M3.7510417 0.86354166C2.8364584 0.86354166 2.2147918 1.6799999 2.2141666 4.9918752C2.2147918 8.3039579 2.8364584 9.1204166 3.7510417 9.1204166C4.6656251 9.1204166 5.2872915 8.3039579 5.2879167 4.9918752C5.2872915 1.6799999 4.6656251 0.86354166 3.7510417 0.86354166M7.5020833 4.9989581L7.5016665 4.9989581C7.4983335 6.5927081 7.1154165 7.8879166 6.3943748 8.7535419C5.7239585 9.5583334 4.8554168 9.9837503 3.75125 9.9837503C2.6466668 9.9837503 1.778125 9.5583334 1.1077083 8.7535419C0.38666666 7.8879166 0.0037499999 6.5927081 0.00020833334 4.9989581L-9.7699626e-15 4.9989581L0.00020833334 4.9918752L-9.7699626e-15 4.9850001L0.00020833334 4.9850001C0.0037499999 3.3910418 0.38666666 2.0960417 1.1077083 1.2304167C1.778125 0.42541668 2.6466668 0 3.75125 0C4.8554168 0 5.7239585 0.42541668 6.3943748 1.2304167C7.1154165 2.0960417 7.4983335 3.3910418 7.5016665 4.9850001L7.5020833 4.9850001L7.5018749 4.9918752L7.5020833 4.9989581"
      />
      <path
        fill="white"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 32.5827 34.8512)"
        d="M0 0L2.0191667 0L2.0191667 4.8102083L5.3708334 4.8102083L5.3708334 5.6791668L2.0191667 5.6791668L2.0191667 8.8468752L5.9372916 8.8468752L5.9372916 9.7160416L0 9.7160416L0 0Z"
      />
      <path
        fill="white"
        transform="matrix(1 8.74228e-08 8.74228e-08 -1 21.4662 34.9852)"
        d="M3.7510417 0.86354166C2.8364584 0.86354166 2.2147918 1.6799999 2.2141666 4.9918752C2.2147918 8.3039579 2.8364584 9.1204166 3.7510417 9.1204166C4.6654167 9.1204166 5.2872915 8.3039579 5.2879167 4.9918752C5.2872915 1.6799999 4.6654167 0.86354166 3.7510417 0.86354166M7.5020833 4.9989581L7.5016665 4.9989581C7.4983335 6.5927081 7.1154165 7.8879166 6.3943748 8.7537498C5.7239585 9.5585413 4.8554168 9.9837503 3.7510417 9.9839582C2.6466668 9.9837503 1.778125 9.5585413 1.1077083 8.7537498C0.38666666 7.8879166 0.0037499999 6.5927081 0.00020833334 4.9989581L-1.1990409e-14 4.9989581L0.00020833334 4.9918752L-1.1990409e-14 4.9850001L0.00020833334 4.9850001C0.0037499999 3.3912499 0.38666666 2.0960417 1.1077083 1.2304167C1.778125 0.42541668 2.6466668 1.3322676e-14 3.7510417 1.3322676e-14C4.8554168 1.3322676e-14 5.7239585 0.42541668 6.3943748 1.2304167C7.1154165 2.0960417 7.4983335 3.3912499 7.5016665 4.9850001L7.5020833 4.9850001L7.5018749 4.9918752L7.5020833 4.9989581"
      />
    </svg>
  );
};

export default HyattBrandFlag;
